import {
  CaseStatusEnum,
  CommercialDealClient,
  CommercialLenderResultSummaryDTO,
  OrganisationClient,
  ProductClient,
} from "@src/apis/ModularClient";

export class CommercialComparisonController {
  isLoading: boolean;
  selectedCandidates: CommercialLenderResultSummaryDTO[];

  //Lender Logos
  showLenderLogo: boolean = false;

  dealId: number;
  uniqueid: string;
  criteria: {} = {};

  //This needs to be set to true as we are using a same view.
  isDeal: boolean = true;

  productLastVerifiedDates = {};

  static $inject = [
    "$scope",
    "$rootScope",
    "$location",
    "$http",
    "OrganisationClient",
    "CommercialDealClient",
    "$routeParams",
    "ProductClient",
  ];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
    private organisationClient: OrganisationClient,
    private commercialDealClient: CommercialDealClient,
    private $routeParams: ng.route.IRouteParamsService,
    private productClient: ProductClient,
  ) {
    this.showOrHideLenderLogo();

    if (this.$routeParams.dealId) {
      this.dealId = this.$routeParams.dealId;
    }

    //if ((this.$rootScope as any).selectedUser || sessionStorage.getItem('SelectedUser')) {
    //    if ((this.$rootScope as any).selectedUser) {
    //        this.selectedUser = (this.$rootScope as any).selectedUser;
    //        sessionStorage.setItem('SelectedUser', JSON.stringify(this.selectedUser));
    //    } else if (sessionStorage.getItem('SelectedUser')) {
    //        this.selectedUser = JSON.parse(sessionStorage.getItem('SelectedUser'));
    //    }
    //}

    if (sessionStorage.getItem("ComparisonList") && sessionStorage.getItem("LoanCriteria")) {
      this.selectedCandidates = JSON.parse(sessionStorage.getItem("ComparisonList"));
      this.criteria = JSON.parse(sessionStorage.getItem("LoanCriteria"));
      const productIds = this.selectedCandidates.map((product) => product.productID);
      this.getProductLastVerifiedDates(productIds);
    } else {
      this.goToResults();
    }
  }

  showOrHideLenderLogo() {
    this.organisationClient.showLenderNamesAndLogos(this.$routeParams.dealId, true).then((result) => {
      this.showLenderLogo = result;
    });
  }

  goToResults(): void {
    sessionStorage.setItem("ComparisonList", JSON.stringify(this.selectedCandidates));

    this.commercialDealClient.fetch(this.dealId).then((result) => {
      if (result.status == CaseStatusEnum.ReadyToReSubmit || result.status == CaseStatusEnum.SubmittedToLendersForHoT) {
        this.$location.path("/commercialshortlistmore/" + this.dealId);
      } else {
        this.$location.path("/commercialresults/" + this.dealId);
      }
    });
  }

  getProductLastVerifiedDates(productIds: number[]) {
    this.productClient.getLastVerifiedDates(productIds).then((response) => {
      productIds.forEach((id) => {
        if (response[id] != null) {
          this.productLastVerifiedDates[id] = this.formatDate(response[id]);
        }
      });
    });
  }

  formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };
}
